import styles from './Dropdown.module.scss'
import Link from 'next/link'
import Icon from "@/components/UI/Icon/Icon";
import classNames from "classnames";
import {useEffect, useRef} from "react";
import {useRouter} from "next/router";

type EntryTypes = 'link' | 'entry' | 'divider'

type LinkEntryProps = {
  href: string
  rel?: string
  target?: string
  text: React.ReactNode
  onClick?: () => void
  type: 'link'
  className?: string
}

const LinkEntry = ({href, rel, target, text, onClick, className}: LinkEntryProps) => {
  return (
    <Link className={classNames(styles.link, className)} href={href} target={target} rel={rel} onClick={onClick}>
      <li className={styles.dropdownItem}>{text}</li>
    </Link>
  )
}

type EntryProps = {
  text: React.ReactNode
  onClick: () => void
  type: 'entry'
  className?: string
}

const Entry = ({text, onClick, className}: EntryProps) => {
  return (
    <li className={classNames(styles.dropdownItem, className)} onClick={onClick}>{text}</li>
  )
}

type DividerType = {type: 'divider', className?: string}

export type DropdownEntryType = LinkEntryProps | EntryProps | DividerType
type Props = {
  trigger: React.ReactNode
  entries: DropdownEntryType[]
  direction?: 'left' | 'right'
}

const  Dropdown = ({trigger, entries, direction}: Props) => {
  const router = useRouter()

  useEffect(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement?.blur()
    }
    
  }, [router.asPath]);

  return (
    <button type="button" tabIndex={0} className={styles.dropdown}>
      <div className={styles.dropdownButton}>
        {trigger}
        <ul className={classNames(styles.dropdownContent, direction === 'right' && styles.right)}>
          {entries.map((entry, index) => {
            if (entry.type === 'link') return <LinkEntry key={index} {...entry} />
            if (entry.type === 'entry') return <Entry key={index} {...entry} />
            if (entry.type === 'divider') return <div key={index} className={classNames(styles.divider, entry.className)}/>
            console.warn('Dropdown entry type not recognized')
            return null
          })}
        </ul>
      </div>
    </button>
  )
}

export default Dropdown